import React from "react";
import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useSelector, useDispatch } from "react-redux";
import useInputChange from "../../../utils/hooks/useInputChange";
import { useLocation } from "react-router-dom";
import { setApplicationInfo } from "../../../redux/slice/customer/customerSlice";
import { isEmptyObject } from "../../../utils/validators/validators";
import { flashMessage } from "../../../utils/flash";
import { useEffect } from "react";
import Form from "../../form/Form";
import useFileUpload from "../../../utils/hooks/useFileUpload";
import useFilter from "../../../utils/hooks/useFilter";

const Identification = ({ nokInfoRef }) => {
  const fileTypes = ["JPG", "PNG", "PDF", "DOC", "DOCX"];
  const { application_info } = useSelector((state) => state.customer);
  const [userInput, setUserInput] = useState({
    identity_type: "",
    date_of_insurance: "",
    date_of_expiration: "",
    identity_number: "",
    document_url: "",
  });
  const [error, setError] = useState({});
  let { removeErrorBySlug } = useFilter(error);
  const [input, handleChange] = useInputChange(
    application_info,
    setUserInput,
    error,
    setError
  );
  const { fileUrl, singleFileUpload } = useFileUpload();
  const [isUploading, setIsUploading] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (isEmptyObject(error)) {
    //   if (!userInput?.document_url) {
    //     flashMessage("error", "Please upload document");
    //   } else {
    //   }
    // }
    nokInfoRef.current.click();

  };

  const handleFileChange = (file) => {
    setIsUploading(true);
    singleFileUpload(file);
  };

  useEffect(() => {
    dispatch(setApplicationInfo(userInput));
    if (userInput.identity_type == "national_id") {
      setError(removeErrorBySlug("date_of_expiration"));
    }
  }, [userInput]);

  useEffect(() => {
    if (fileUrl) {
      setIsUploading(false);
      setUserInput({ ...userInput, document_url: fileUrl });
    }
  }, [fileUrl]);

  return (
    <div className='border border-top-0 px-3'>
      {/* <Form setError={setError} submitHandler={handleSubmit} values={userInput}> */}
      <form onSubmit={handleSubmit}>
        <div className='row mb-2'>
          <div className='mb-0 mt-3 col-md-4'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Identification type</span>
              {/* <span className='text-danger'>*</span> */}
            </label>
            <select
              textname='means of identification'
              validate='false'
              name='identity_type'
              onChange={handleChange}
              value={input.identity_type}
              type='date'
              id='identity_type'
              className={`form-select ${error.identity_type && "is-invalid"}`}
            >
              <option value=''>-- Select --</option>
              <option value='drivers_license'>Drivers License</option>
              <option value='national_id'>National ID Card</option>
              <option value='passport'>National Passport</option>
              <option value='voters_card'>Voter's Card</option>
            </select>
            {error.identity_type && (
              <span className='invalid-feedback'>{error.identity_type}</span>
            )}
          </div>
          {userInput?.identity_type !== "national_id" && (
            <div className='mb-0 mt-3 col-md-4'>
              <label htmlFor='inputEmail4' className='form-label'>
                Date of Issuance
                {/* <span className='text-danger'>*</span> */}
              </label>
              <input
                type='date'
                textname='date of issuance'
                name='date_of_insurance'
                validate='false'
                onChange={handleChange}
                value={input.date_of_insurance}
                id='date_of_insurance'
                className={`form-control ${
                  error.date_of_insurance && "is-invalid"
                }`}
              />
              {error.date_of_insurance && (
                <span className='invalid-feedback'>
                  {error.date_of_insurance}
                </span>
              )}
            </div>
          )}
          {userInput?.identity_type !== "national_id" && (
            <div className='mb-0 mt-3 col-md-4'>
              <label htmlFor='inputEmail4' className='form-label'>
                Date of Expiry
                {/* <span className='text-danger'>*</span> */}
              </label>
              <input
                type='date'
                textname='date of expiry'
                name='date_of_expiration'
                validate='false'
                onChange={handleChange}
                value={input.date_of_expiration}
                id='date_of_expiration'
                className={`form-control ${
                  error.date_of_expiration && "is-invalid"
                }`}
              />
              {error.date_of_expiration && (
                <span className='invalid-feedback'>
                  {error.date_of_expiration}
                </span>
              )}
            </div>
          )}

          <div className='mb-0 mt-3 col-md-4'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Identification Number</span>
              {/* <span className='text-danger'>*</span> */}
            </label>
            <input
              type='text'
              textname='identification number'
              name='identity_number'
              onChange={handleChange}
              value={input.identity_number}
              id='identity_number'
              className={`form-control ${
                error.identity_number && "is-invalid"
              }`}
              placeholder='Enter ID number'
              validate='false'
            />
            {error.identity_number && (
              <span className='invalid-feedback'>{error.identity_number}</span>
            )}
          </div>

          <div className='col-md-4 mt-3'>
            <label htmlFor='inputEmail4' className='form-label d-block'>
              Upload Document
              {/* <span className='text-danger'>*</span> */}
              {isUploading && (
                <span className='bg-dar ms-1 text-danger'>
                  {" "}
                  <i
                    className={`mdi mdi-dots-circle mdi-spin fs-5 h3 mt-0`}
                  ></i>{" "}
                </span>
              )}
              {!isUploading && application_info?.document_url && (
                <span className='bg-dar ms-1 text-success'>
                  {" "}
                  <i className={`mdi mdi-check fs-5 h3 mt-0`}></i>{" "}
                </span>
              )}
            </label>
            <FileUploader
              label=' Browse Document'
              children={
                <div
                  className='borde border-dotted p-1 px-2 text-center cursor-p'
                  style={{ border: "2px dashed grey" }}
                  //   onClick={handleChange}
                  //   onDrop={handleChange}
                >
                  <i className='uil uil-cloud-upload fs-4'></i> Upload Document
                  <span className='text-primary-dark mt-0'></span>
                </div>
              }
              handleChange={handleFileChange}
              onDrop={handleFileChange}
              name='file'
              types={fileTypes}
            />
          </div>
        </div>
        <div className='d-flex justify-content-end mb-3 mt-2'>
          <button
            type='submit'
            className='btn btn-primary'
            disabled={isUploading ? true : false}
          >
            Proceed
          </button>
        </div>
      </form>
    </div>
  );
};

export default Identification;
